import React, { useState, useContext, useEffect, useRef } from "react";
import "../../../ui-styles/sliders/RightFullSlider.css";
import "../../../ui-styles/invitation/invitationList.css";
import { LangCtx, InstavcCtx, PayLoadCtx } from "../../../lib/context";
import NoData from "../../../lib/ui/nodata/NoData";
import { getInvitees, createInvitee } from '../../../actions/schedule';
import { validateEmail } from "../../../lib/validation";
import { useParams } from 'react-router-dom';
import { sendInviteLink } from "../../../actions/appointment";
import ConfInviteItem from "./Inviteitem";
import Loader from "../../../lib/ui/loader/Loader";

const ConfInviteSlide = (props) => {
    const { l } = useContext(LangCtx);
    // const { invitees, setInvitees } = useState({});
    // const { appointmentData } = props
    const [errorMsg, setErrorMsg] = useState(null);
    const [invitees, setInvitees] = useState([]);
    const [invitee, setInvitee] = useState('');
    const { id } = useParams();
    const origin = window.location.origin;
    const { appointmentData } = useContext(InstavcCtx);
    const { payload } = useContext(PayLoadCtx);
    const linkRef = useRef();
    const { doctorData } = appointmentData;
    const [loading, setLoading] = useState(false);

    useEffect(() =>
        loadInvitees()
    , [doctorData.userId]);

    const loadInvitees = () => {
        setLoading(true);
        getInvitees(`?sub=${payload.userId}&appointmentId=${appointmentData?.appointmentId}`).then((res) => {
            if (res.status) {
                console.log("response of invited emails are ....... ",res);
                // let _invitees = [...invitees];
                // for(let i in res.data) {
                //     let inx = _invitees.findIndex(it => it.email === i.email);
                //     if (inx <= -1) {
                //         _invitees.push(res.data[i]);
                //     }
                // }
                const processedInvitees = res?.data?.getData.map((invitee) => {
                    if (invitee?.invitedEmail) {
                        return {
                            email: invitee?.invitedEmail,
                            name: "", 
                            userId: "",
                            createdAt: null,
                            _id: ""
                        };
                    }
                    return invitee;
                });

                setInvitees(processedInvitees);
                setLoading(false);
            }
            setLoading(false);
        }).catch(err => {
            console.log("err in get invitees==== ", err);
            setLoading(false);
        })
    }

    const handleCopy = (e) => {
        let ele = linkRef.current;
        ele.select();
        document.execCommand("copy");
    }

    const handleInvitation = (i) => {
        let _invitees = [...invitees];
        _invitees[i] = { ..._invitees[i], 'sending': true };
        setInvitees(_invitees);

        let body = {
            clinicId:appointmentData.clinicId,
            email: invitees[i].email,
            link: `${origin}/guest-settings/${id}`,
            fname: payload && payload.firstName ? payload.firstName : '',
            lname: payload && payload.lastName ? payload.lastName : '',
            startTime: appointmentData && appointmentData.startTime ? appointmentData.startTime : new Date().valueOf(),
            endTime: appointmentData && appointmentData.endTime ? appointmentData.endTime : new Date().valueOf(),
            logo: `${origin}/Templates/logo/logo.png`
        }
            console.log(body,"body")
            console.log(body,"bodyitems")
        sendInviteLink(body).then(res => {
            let _ivts = [...invitees];
            _ivts[i] = { ..._ivts[i], ...{ 'sending': false, 'sent': true } };
            setInvitees(_ivts);
        }).catch(err => {
            let _ivts = [...invitees];
            _ivts[i] = { ..._ivts[i], ...{ 'sending': false, 'sent': false } };
            setInvitees(_ivts);
            console.log("err ==== ", err);
        })
    }

    const validate = () => {
        if (invitee === '' || invitee === null) {
            setErrorMsg(l.pls_enter_email)
            return false
        }
        else if (!validateEmail(invitee)) {
            setErrorMsg(l.pls_check_email)
            return false
        }
        else if (invitees.length > 0 && invitees.find((data) => data.email === invitee)) {
            setErrorMsg(l.email_exs_alrdy)
            return false
        }

        setErrorMsg('')
        return true
    }

    const handleCreateInvitee = (e) => {
        e.preventDefault();
        try {
            let body = {
                email: invitee.toLowerCase(),
                name: invitee.substring(0, invitee.lastIndexOf("@"))
            }


            if (validate()) {
                createInvitee(body, payload.userId).then(res => {
                    if (res.status) {
                        setInvitee('');
                        loadInvitees()
                    }
                }).catch(err => {
                    setErrorMsg(l.unable_crt_invite)
                });
            }
        } catch (e) {

            console.log("Error", e);
            setErrorMsg(l.went_worng_pls_try_again)
        }
    }

    return (
        <div className={props.confInvite ? "rightFullSlider fullSlide rightSliderIn" : "rightFullSlider fullSlide"}>
            <div className="rightSliderHdr">
                <div className="hdrRowBlock">
                    <div className="hdrTitleBox">
                        <span>{l.invite}</span>
                    </div>
                    <div className="hdrActionGroup" onClick={props.close}>
                        <div className="hdrActItem close"></div>
                    </div>
                </div>
            </div>
            <div className="rightSliderBdy">
                <div className="inviteColBlock">
                    <p className="inviParaTxt">{l.invite_desc}</p>
                    <div className="copyListRow">
                        <div className="copyInputBox">
                            <input type="text" ref={linkRef} className="copyInput" value={`${origin}/guest-settings/${id}`} />
                        </div>
                        <div className="copyCopyBox lightBg" onClick={handleCopy}>
                            <img src="/images/icons/copy-link.png" alt="icon" className="invertPrimary"/>
                        </div>
                    </div>
                </div>
                <div className="inviteEmailCol">
                    {errorMsg &&
                        <div className="errorBox">
                            <small className="errorTxt">{errorMsg}</small>
                        </div>
                    }
                    <div className="addInputRow">
                        <div className="copyListRow">
                            <div className="copyInputBox">
                                <input type="text" className="copyInput txtBlack"
                                    placeholder={l.add_email}
                                    value={invitee}
                                    onChange={(e) => setInvitee(e.target.value)}
                                />
                            </div>
                            <div className="copyCopyBox primayBg" onClick={handleCreateInvitee}>
                                <span>{l.addbtn}</span>
                            </div>
                        </div>
                    </div>
                    {loading ? (<Loader />) :
                        (<ul className="emailListGroup">
                        
                            {invitees ? invitees.map((invitee, i) => <ConfInviteItem index={i} l={l} invitee={invitee} handleInvitation={handleInvitation} />)
                                : <NoData Heading={l.NoData} src="/images/file-icons/blank-file.png" label='' />
                            }
                        </ul>)
                    }
                </div>
            </div>

        </div>
    )
}

export default ConfInviteSlide;